import { __assign, __read, __spreadArray } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from '../../Style/MoaStyled';
import { ResponsiveLine } from '@nivo/line';
var StyledComponent = styled(function (props) {
    /**
     * 최대값과 최소값 계산 (x, y)
     */
    // 모든 x 값들과 y 값들에 대한 배열을 만듭니다.
    var allXValues = props.data.flatMap(function (series) { return series.data.map(function (point) { return point.x; }); });
    var allYValues = props.data.flatMap(function (series) { return series.data.map(function (point) { return point.y; }); });
    // 모든 x 값들 중에서 최소값과 최대값, 모든 y 값들 중에서 최소값과 최대값을 계산합니다.
    var minX = Math.min.apply(Math, __spreadArray([], __read(allXValues), false));
    var maxX = Math.max.apply(Math, __spreadArray([], __read(allXValues), false));
    var minY = Math.min.apply(Math, __spreadArray([], __read(allYValues), false));
    var maxY = Math.max.apply(Math, __spreadArray([], __read(allYValues), false));
    /**
     * Grid 갯수 계산 (x, y)
     */
    // x축의 grid 갯수를 계산합니다.
    var xGridCount = Math.max(props.axisTopTickValues || 0, props.axisBottomTickValues || 0);
    // y축의 grid 갯수를 계산합니다.
    var yGridCount = Math.max(props.axisLeftTickValues || 0, props.axisRightTickValues || 0);
    return (_jsx("div", { style: {
            width: props.width,
            height: props.height,
        }, children: _jsx(ResponsiveLine, { data: props.data, colors: props.data.map(function (item) { return item.color; }), margin: {
                top: props.marginTop || 50,
                right: props.marginRight || 110,
                bottom: props.marginBottom || 50,
                left: props.marginLeft || 60,
            }, xScale: {
                type: 'linear',
                stacked: false,
                reverse: false,
                min: minX,
                max: maxX,
            }, xFormat: ">-.".concat(props.xDecimals || 2, "f"), yScale: {
                type: 'linear',
                stacked: false,
                reverse: false,
                min: minY,
                max: maxY,
            }, yFormat: ">-.".concat(props.yDecimals || 2, "f"), gridXValues: xGridCount !== 0 ? xGridCount : undefined, gridYValues: yGridCount !== 0 ? yGridCount : undefined, axisTop: props.axisTop ? {
                tickValues: props.axisTopTickValues || undefined,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: props.axisTopTickRotation || undefined,
                legend: props.axisTopLegend || undefined,
                legendOffset: props.axisTopLegendOffset || -36,
                legendPosition: props.axisTopLegendPosition || "middle",
                format: function (value) { return value.toFixed(props.axisTopDecimals); }, //소수점 2째자리까지 표기
            } : null, axisRight: props.axisRight ? {
                tickValues: props.axisRightTickValues || undefined,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: props.axisRightTickRotation || undefined,
                legend: props.axisRightLegend || undefined,
                legendOffset: props.axisRightLegendOffset || 40,
                legendPosition: props.axisRightLegendPosition || "middle",
                format: function (value) { return value.toFixed(props.axisRightDecimals); }, //소수점 2째자리까지 표기
            } : null, axisBottom: props.axisBottom ? {
                tickValues: props.axisBottomTickValues || undefined,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: props.axisBottomTickRotation || undefined,
                legend: props.axisBottomLegend || undefined,
                legendOffset: props.axisBottomLegendOffset || 36,
                legendPosition: props.axisBottomLegendPosition || "middle",
                format: function (value) { return value.toFixed(props.axisBottomDecimals); }, //소수점 2째자리까지 표기
            } : null, axisLeft: props.axisLeft ? {
                tickValues: props.axisLeftTickValues || undefined,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: props.axisLeftTickRotation || undefined,
                legend: props.axisLeftLegend || undefined,
                legendOffset: props.axisLeftLegendOffset || -40,
                legendPosition: props.axisLeftLegendPosition || "middle",
                format: function (value) { return value.toFixed(props.axisLeftDecimals); }, //소수점 2째자리까지 표기
            } : null, pointSize: props.pointSize, pointColor: { theme: "background" }, pointBorderWidth: 8, pointBorderColor: { from: "serieColor" }, pointLabelYOffset: -12, useMesh: true, curve: "linear", legends: props.legends ? [
                {
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: "left-to-right",
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: "circle",
                    symbolBorderColor: "rgba(0, 0, 0, .5)",
                    effects: [
                        {
                            on: "hover",
                            style: {
                                itemBackground: "rgba(0, 0, 0, .03)",
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ] : [] }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
